import React from 'react';
import { Tag, Text, Tooltip } from '@alefeducation/ui-elements-library-core';
import styled from 'styled-components';
import useOrganisationsNameMutation from '../../pages/hooks/useOrganisationsName.mutation';

interface OrganisationTagProps {
  orgCode: string;
  userId: string;
}

const StyledTag = styled(Tag)`
  margin-right: ${({ theme: { space } }: any) => `${space[8]}px`};
`;

const MemberOrganisationTag: React.FC<OrganisationTagProps> = ({
  orgCode,
  userId,
}) => {
  const [getOrgNames, { organisations }] = useOrganisationsNameMutation();
  const [org] = organisations;
  const content = org ? org.name : '...';

  return (
    <span
      onMouseEnter={() => {
        getOrgNames([orgCode]);
      }}
      data-testid="organisation-code-tag"
    >
      <StyledTag>
        <Tooltip content={content} id={`${orgCode.trim()}-${userId}`}>
          <Text
            variant="body-large"
            color="primary.100"
            weight="light"
            data-testid={'member-row-field-organisation'}
          >
            {orgCode}
          </Text>
        </Tooltip>
      </StyledTag>
    </span>
  );
};

export default MemberOrganisationTag;
